import { get } from "../methods";
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["Event"] = "event";
  EventType2["Article"] = "article";
  EventType2["Brief"] = "brief";
  EventType2["ExternalArticle"] = "external-article";
  return EventType2;
})(EventType || {});
function getMarketFeed(market, industryId, headers = {}) {
  let url = `api/market/activities/${market}`;
  if (industryId) {
    url += `/${industryId}`;
  }
  return get({
    url,
    headers
  });
}
export {
  getMarketFeed as default
};
